export default "__VITE_ASSET__271qTx15__"